/* ============================================================================
   FLIPSI · PIROUETTE · PRODUCT PAGE V3 · lights toggle + quantity stepper
   Real add-to-cart is a native {% form 'product' %} — the theme's own
   site-wide cart scripts already intercept and route it into the cart
   drawer, so nothing bespoke is wired here. This file only owns the things
   unique to this page: the lights toggle and its aria state, and the
   quantity stepper's -/+ buttons (native number input underneath).
   ========================================================================= */
(function(){
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLights(root){
    var zone = root.querySelector('.fps-pirpdp-lx');
    var btn = root.querySelector('.fps-pirpdp-lx-btn');
    if(!zone || !btn){ return; }
    var labelDown = btn.getAttribute('data-label-down') || 'Turn the lights down';
    var labelUp = btn.getAttribute('data-label-up') || 'Turn the lights up';
    var labelEl = btn.querySelector('.fps-pirpdp-lx-btn__label');
    function sync(){
      var down = zone.classList.contains('fps-pirpdp-is-down');
      btn.setAttribute('aria-pressed', String(down));
      if(labelEl){ labelEl.textContent = down ? labelUp : labelDown; }
    }
    btn.addEventListener('click', function(){
      zone.classList.toggle('fps-pirpdp-is-down');
      sync();
    });
    sync();
    if(reduced){ zone.classList.add('fps-pirpdp-no-motion'); }
  }

  function initQty(root){
    var qtyWraps = [].slice.call(root.querySelectorAll('.fps-pirpdp-qty'));
    qtyWraps.forEach(function(wrap){
      var input = wrap.querySelector('input[name="quantity"]');
      var minus = wrap.querySelector('[data-qty-minus]');
      var plus = wrap.querySelector('[data-qty-plus]');
      if(!input){ return; }
      function clamp(v){ return Math.max(1, v); }
      if(minus){
        minus.addEventListener('click', function(){
          input.value = clamp((parseInt(input.value, 10) || 1) - 1);
          input.dispatchEvent(new Event('change', { bubbles:true }));
        });
      }
      if(plus){
        plus.addEventListener('click', function(){
          input.value = clamp((parseInt(input.value, 10) || 1) + 1);
          input.dispatchEvent(new Event('change', { bubbles:true }));
        });
      }
      input.addEventListener('change', function(){
        input.value = clamp(parseInt(input.value, 10) || 1);
      });
    });
  }

  function initFaqAnalyticsFreeToggle(root){
    /* native <details>/<summary> — no JS required for the open/close state
       itself; this is just here so multiple opens don't need extra wiring. */
  }

  function init(){
    document.querySelectorAll('.fps-pirpdp').forEach(function(root){
      initLights(root);
      initQty(root);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* theme editor: re-run if this section is reloaded while editing */
  document.addEventListener('shopify:section:load', function(e){
    if(e.target && e.target.querySelector && e.target.querySelector('.fps-pirpdp')){ init(); }
  });
})();
